<template>
	<div class="ptlr-60-16 box-s">
		<div class="bg_f ps_top">
			<NavList @getItem="getItem" :navList="navList"></NavList>
		</div>
		<div class="">
			<van-list
				v-model="loading"
				:finished="finished"
				:finished-text="finishedtext"
				:immediate-check="false"
				@load="initMainData"
			>
			  <div class="list_every pd-16-18 box-s mb-16 pra_every" v-for="(item, index) in list" :key="index">
					<div class="flexs flex-jus">
						<div class="flexs">
							<img class="wh_46 b-radius-50 mr-10" src="../../assets/img/icon/pass_icon.png" alt="">

							<div class="fw-500 fz-16 c1">{{item.gate_level_name}}</div>
						</div>
						<!-- //c10 -->
						<div class="flexs bg_ec whl-74-24 flex-center fw-500 fz-12 b-radius-12 c0" :class="{ 'orange_sty': item.is_lock == null || item.is_lock == 2 }" @click="getStart(item, index)"> 
							{{item.is_lock == 0? '开始闯关': item.is_lock == 1?'重新闯关':item.is_lock == null?'立即解锁':item.is_lock == 2?'分享解锁': '开始闯关'}}
							<img v-if="item.is_lock == 0 || item.is_lock == 1" class="wh_4_6 ml-5" src="../../assets/img/icon/blue_right_arrow.png" alt="">
							<img v-else class="wh_4_6 ml-5" src="../../assets/img/icon/orange_suo.png" alt="">
						</div>
					</div>

					<div class="fw-500 fz-14 c1 pd-16 box-s bg_f9 b-radius-6 mtb-16">题目数量： {{item.question_num}}题</div>

					<div class="flexs">
						<div class="flex1 pl-14 box-s">
							<div class="mb-14 fz-12 c1">答题限时</div>
							<div class="fz-14 c3">{{item.time_limit}}分钟</div>
						</div>
						<div class="flex1 pl-14 box-s">
							<div class="mb-14 fz-12 c1">过关正确率</div>
							<div class="fz-14 c3">{{item.accuracy_percent}}%</div>
						</div>
					</div>
				</div>
			</van-list>
			
		</div>
		<noData v-if="show"></noData>
		<loading :loadFlag="loadFlag"></loading>
    <shareBg v-if="showShare" @hideShare="shareBtn"></shareBg>
    <shareOk v-if="showShareOk" @hideShare="shareBtnOk" :pass="true" ></shareOk>		
	</div>
</template>
<script>

	import { gateLevelSubject, getGateLevel, shareUnlockGateLevel } from '@/api/api.js'
	import NavList from '@/components/navList';
	import noData from "@/components/noData"
	import loading from "@/components/loading"
	import shareBg from '@/components/shareBg.vue';
  import shareOk from '@/components/shareOk.vue';
	import { getList, clear, getConfig, getShare } from '@/utils/common'
	export default {
		components: {
			NavList,
			noData,
			loading,
			shareBg,
			shareOk
		},
		data() {
			return {
			  list: [],//闯关数据
				navList: [],//导航栏数据
				show: false,//没有数据时展示
				loadFlag: false,//loading展示
        showShare: false,//分享组件展示
        showShareOk: false,//分享成功组件展示
				gate_level_user_id: '',//用户闯关记录ID
				index: '',//选中的index
				loading: false,
				finished: false,
				finishedtext: '',
				page: 1,
				loadFlag: false,
				subject_id: ''
			};
		},
		created() {
			clear()
			getShare().then(async()=>{
        const res = await shareUnlockGateLevel({ gate_level_user_id: this.gate_level_user_id })
				if(res.code == 1000){
					this.showShare = false
					this.showShareOk = true
					this.list[this.index].is_lock = 0
				} else {
					if(res.code == 10001){
            this.$toast('请先完成前面的关卡')
					}else{
            this.$toast(res.msg)
					}
					
				}
      }).catch(()=>{})
      this.initData()
		},
		mounted(){
		},
		methods: {

			async initData(){
				const res = await gateLevelSubject()
				if(res.code == 1000){
          this.navList = res.data
					this.subject_id = this.navList[0].id
					this.initMainData()
				} else {
            this.$toast(res.msg)
          }
			},

			initMainData(){
				if(!this.subject_id){
          return
				}
				getList(this, getGateLevel, { subject_id: this.subject_id, page: this.page })
			},

			// 闯关列表
			getItem(data){
				this.subject_id = data.item.id
				this.page = 1
				this.show = false
				this.loading = false,
				this.finishedtext =  '',
				this.list = []
				console.log(this.subject_id,999)
				this.finished =  false
				
				getList(this, getGateLevel, { subject_id: this.subject_id, page: this.page })
			},	

			// 开始答题
			getStart(item, index){
				if(item.is_lock == 0){
					if(item.question_num == 0){
					  return this.$toast('暂无题目，无法做题哦~')
				  }
					this.$router.push({ path: '/passstartquset', query: {id: item.id,time_limit: item.time_limit, gate_level_user_id: item.gate_level_user_id} })
				} else if(item.is_lock == 1) {
					this.$router.push({ path: '/passreport', query: { id: item.gate_level_user_id, cid: item.id, time_limit: item.time_limit } })
				} else if(item.is_lock == 2){
					this.showShare = true
					this.gate_level_user_id = item.gate_level_user_id
					this.index = index
				} else if(item.is_lock == null){
					this.$toast('请先完成前面的关卡')
				}
			},
			// 分享的积分
		async shareBtn(){
			this.showShare = !this.showShare
      },
      // 恭喜的积分
      shareBtnOk(){
        this.showShareOk = !this.showShareOk
      }

		}
	};
</script>
<style lang="less" scoped>

.orange_sty {
	background: #FFF4EA;
	color: #FFAB5A;
}

/deep/.van-list__finished-text {
	line-height: 20px !important;
	padding-bottom: 10px;
}
/deep/.van-list__loading {
	display: none;
}
</style>
